export var EEX_PATHS;
(function (EEX_PATHS) {
    EEX_PATHS["DISCORD"] = "https://discord.gg/Sundae";
    EEX_PATHS["LEGAL"] = "https://www.sundaeswap.finance/terms";
    EEX_PATHS["LEARN_MORE_WALLETS"] = "https://help.sundaeswap.finance/en/collections/3303291-wallets";
    EEX_PATHS["FORUM"] = "https://forum.sundaeswap.finance";
    EEX_PATHS["DISCLAIMER"] = "https://sundaeswap.finance/terms";
    EEX_PATHS["PRIVACY"] = "https://sundaeswap.finance/privacy";
    EEX_PATHS["TERMS"] = "https://sundaeswap.finance/terms";
    EEX_PATHS["TWITTER"] = "https://twitter.com/SundaeSwap";
    EEX_PATHS["MEDIUM"] = "https://sundaeswap-finance.medium.com/";
    EEX_PATHS["FAQ"] = "https://help.sundaeswap.finance/en/";
})(EEX_PATHS || (EEX_PATHS = {}));
export var EPATHS;
(function (EPATHS) {
    EPATHS["CREATE_PROPOSAL"] = "/create";
    EPATHS["PROPOSAL_DETAIL"] = "/proposal";
    EPATHS["PROPOSAL_OVERVIEW"] = "/";
})(EPATHS || (EPATHS = {}));
//# sourceMappingURL=paths.js.map